import React from 'react';
import { createQColumnHelper } from '@qualio/ui-components';
import { UserTableData } from '../../../types';
import { formQbadge, withBreakAfterAt } from '../../../utils/users.utils';
import { IndividualUserMenu } from './IndividualUserMenu';

export const buildColumns = (
  handleUserAction: (actionItemId: string, userRow: UserTableData) => void,
  t: (key: string) => string,
  showProfileFields = false,
) => {
  const columnHelper = createQColumnHelper<UserTableData>();
  return [
    columnHelper.text('fullName', {
      header: t('users.table.fullName'),
      minWidth: '140px',
      weight: 3,
    }),
    {
      accessorKey: 'email',
      cell: (props: any) => (
        <div key={`${props.row.original.email}-emailDisplay`}>
          <div>{withBreakAfterAt(props.row.original.email)}</div>
          <div>{formQbadge(props.row.original.inviteStatus)}</div>
        </div>
      ),
      header: t('users.table.email'),
      meta: {
        'data-cy': 'email-data-cy',
        minWidth: '200px',
        weight: 4,
      },
    },
    columnHelper.text('role', {
      header: t('users.table.role'),
      minWidth: '100px',
      maxWidth: '140px',
      weight: 1,
    }),
    ...(showProfileFields
      ? [
          columnHelper.text('jobTitle', {
            header: t('users.table.jobTitle'),
            minWidth: '120px',
            weight: 2,
          }),
          columnHelper.text('department', {
            header: t('users.table.department'),
            minWidth: '120px',
            weight: 2,
          }),
          columnHelper.text('location', {
            header: t('users.table.location'),
            minWidth: '120px',
            weight: 2,
          }),
        ]
      : []),
    columnHelper.text('groups', {
      header: t('users.table.groups'),
      minWidth: '150px',
      weight: 4,
    }),
    columnHelper.text('access', {
      header: t('users.table.access'),
      minWidth: '110px',
      maxWidth: '150px',
      weight: 1,
    }),
    columnHelper.menu({
      items: IndividualUserMenu(handleUserAction, t),
    }),
  ];
};
